import apiClient from './axios';
import { normalizeCouponSerialSearch } from './search';

export async function createCoupon({ serialNumber, credit, payable }) {
  const res = await apiClient.post('/v3/coupon', {
    serialNumber,
    credit,
    payable,
  });

  return res.data;
}

export async function fetchCoupons({ offset = 0, limit = 50, search = '' } = {}) {
  // console.log(`fetchCoupons ${offset} to ${offset+limit}`);
  const serialNumberSearch = normalizeCouponSerialSearch(search);

  if (serialNumberSearch) {
    const res = await apiClient.get('/v3/coupon', {
      params: {
        serialNumber: serialNumberSearch,
      },
    });
    const coupon = res.data;
    const foundCoupon = coupon?.uuid && coupon?.serialNumber ? coupon : null;
    const isRegistered = Boolean(foundCoupon?.wallet?.uuid || foundCoupon?.walletUuid);

    return {
      ...res,
      data: {
        total: foundCoupon ? 1 : 0,
        registered: isRegistered ? 1 : 0,
        nonRegistered: foundCoupon && !isRegistered ? 1 : 0,
        offset: 0,
        limit: 1,
        coupons: foundCoupon ? [foundCoupon] : [],
      },
    };
  }

  const res = await apiClient.get('/v3/coupon', {
    params: { 
      offset: offset, 
      limit: limit,
    },
  });

  // console.log(`fetchCoupons -> ${ JSON.stringify( res, null, 2 )}`);

  return res;
}

export async function registerCouponToUser({ serialNumber, userUuid }) {
  const res = await apiClient.post('/v3/coupon/register', {
    userUuid: userUuid,
    serialNumber: serialNumber,
  });

  return res;
}
